import { render, staticRenderFns } from "./v2Index.vue?vue&type=template&id=5de81cf5&scoped=true&"
import script from "./v2Index.vue?vue&type=script&lang=js&"
export * from "./v2Index.vue?vue&type=script&lang=js&"
import style0 from "./v2Index.vue?vue&type=style&index=0&id=5de81cf5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de81cf5",
  null
  
)

export default component.exports